import React, { useEffect, useState } from "react";
import { Bell, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { pushSupported, isPushEnabled, enablePush, ensurePushSubscribed } from "../lib/push";

const KEY = "rl_push_nudge_dismissed_at";
const COPY = {
  customer: "Recharge approve, withdrawal, result, win — app மூடியிருந்தாலும் phone-ல alert வரும்.",
  agent: "Customer recharge / withdrawal request, show close → sheet ready, result — app மூடியிருந்தாலும் வரும்.",
  admin: "Recharge / withdrawal requests, show close → sheet ready (Tap to send), results — app மூடியிருந்தாலும் வரும்.",
};

/* Sticky "turn on notifications" card for every logged-in role; re-subscribes silently when permission already granted. */
export const PushNudge = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!user || !pushSupported()) return;
    let alive = true;
    (async () => {
      if (Notification.permission === "granted") { await ensurePushSubscribed(); if (alive) setShow(false); return; }
      if (Notification.permission === "denied") return;
      const on = await isPushEnabled();
      const dismissed = Number(localStorage.getItem(KEY) || 0);
      if (alive && !on && Date.now() - dismissed > 2 * 24 * 3600 * 1000) setShow(true);
    })();
    return () => { alive = false; };
  }, [user]);
  if (!user || !show) return null;
  const role = user.role === "admin" ? "admin" : user.role === "agent" ? "agent" : "customer";
  const on = async () => {
    setBusy(true);
    try { await enablePush(); setShow(false); toast.success("🔔 Notifications ON — alerts இனி phone-லயே வரும்"); }
    catch (e) { toast.error(e.message || "Could not enable"); if (Notification.permission === "denied") setShow(false); }
    finally { setBusy(false); }
  };
  const later = () => { localStorage.setItem(KEY, String(Date.now())); setShow(false); };
  return (
    <div className="fixed left-3 right-3 bottom-20 md:bottom-6 md:left-auto md:right-6 md:w-96 z-[60] rounded-2xl bg-slate-900 text-white p-4 shadow-2xl border border-amber-400/40" data-testid="push-nudge">
      <button onClick={later} className="absolute top-2 right-2 text-slate-400" data-testid="push-nudge-later"><X className="w-4 h-4" /></button>
      <div className="flex items-start gap-3">
        <span className="w-10 h-10 rounded-full bg-amber-400 text-slate-900 flex items-center justify-center shrink-0"><Bell className="w-5 h-5" /></span>
        <div className="flex-1 min-w-0">
          <div className="font-black text-sm">🔔 Notifications ON பண்ணுங்க</div>
          <div className="text-[11px] text-slate-300 mt-0.5">{COPY[role]}</div>
          <button onClick={on} disabled={busy} className="mt-3 w-full py-2.5 rounded-xl bg-amber-400 text-slate-900 text-sm font-black flex items-center justify-center gap-1 disabled:opacity-60" data-testid="push-nudge-enable">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Bell className="w-4 h-4" />}Turn ON notifications</button>
        </div>
      </div>
    </div>
  );
};
